import { MuiThemeProvider } from '@material-ui/core/styles'
import { AuthProvider } from '@praxis/component-auth'
import { BrowserRouter as Router } from 'react-router-dom'
import '@enterprise-ui/canvas-ui-css'
import '@enterprise-ui/canvas-ui-css-autocomplete'
import '@enterprise-ui/canvas-ui-css-datepicker'
import muiTheme from './config/themeConfig'
import apiConfig from './apiConfig'
import Layout from './components/Layout/Layout'
import { CssBaseline } from '@material-ui/core'
import Interceptor from './services/httpInterceptor'
import history from 'components/Router/history'
import ErrorBoundary from 'components/ErrorBoundary'
import { EnvProvider } from '@praxis/component-runtime-env'
import LayoutItemHub from 'components/Layout/LayoutItemHub'
import { itemCommonUtilis } from 'item-component'
import './styles/common.scss'
import './styles/addFilter.scss'
import './styles/customCanvasTable.scss'
import './styles/orderSummary.scss'
import './styles/vendorShipSamples.scss'
import '@enterprise-ui/canvas-ui-css'
import '@enterprise-ui/canvas-ui-css-autocomplete'
import '@enterprise-ui/canvas-ui-css-datepicker'
import {
  DEV_API_KEY,
  STG_API_KEY,
  IH_DEV_API_KEY,
  IH_PRD_API_KEY,
  PRD_API_KEY,
} from './apiConfig'

import { OpenTelemetryManager } from '@measurement/opentelemetry-web'

const apiKeyMap = {
  dev: DEV_API_KEY,
  stg: STG_API_KEY,
  peg_ih_pol: IH_DEV_API_KEY,
  peg_ih_pol_prod: IH_PRD_API_KEY,
  prod: PRD_API_KEY,
}
const applicationName = ['peg_ih_pol'].includes(process.env.REACT_APP_ENV)
  ? 'pegasus'
  : [
        'partnersonline_stg',
        'pol_stg',
        'partnersonline_prd',
        'pol_prod',
      ].includes(process.env.REACT_APP_ENV)
    ? 'pegasuspol'
    : [
          'peg_ih_pol_prd',
          'peg_ih_pol_stg',
          'peg_ih_stg',
          'peg_ih_pol_prod',
          'peg_ih_prod',
        ].includes(process.env.REACT_APP_ENV)
      ? 'pegasusihpol'
      : 'pegasus'
const environment = ['qa', 'peg_ih_pol', 'pol_dev'].includes(
  process.env.REACT_APP_ENV
)
  ? 'dev'
  : [
        'partnersonline_stg',
        'pol_stg',
        'peg_ih_pol_stg',
        'stg',
        'peg_ih_stg',
      ].includes(process.env.REACT_APP_ENV)
    ? 'stage'
    : [
          'prod',
          'peg_ih_pol_prd',
          'partnersonline_prd',
          'peg_ih_pol_prod',
          'peg_ih_prod',
          'pol_prod',
        ].includes(process.env.REACT_APP_ENV)
      ? 'prod'
      : process.env.REACT_APP_ENV
const apiKey = apiKeyMap[environment] || DEV_API_KEY
const config = {
  apiKey: apiKey,
  serviceName: applicationName,
  enableConsoleExporter: true,
  environment: environment,
}

OpenTelemetryManager.initialize(config)

const basePath = itemCommonUtilis.findAppPath()
const configPath =
  process.env.NODE_ENV === 'development'
    ? `${basePath}/config.json`
    : `${basePath}/app-environment`

const App = () => (
  <EnvProvider configPath={configPath}>
    <MuiThemeProvider theme={muiTheme}>
      <CssBaseline />
      <AuthProvider {...apiConfig.auth}>
        <Router basename={itemCommonUtilis.findAppPath()} history={history}>
          <Interceptor>
            <ErrorBoundary>
              {process.env.REACT_APP_ENV.indexOf('peg_ih_pol') !== -1 ? (
                <LayoutItemHub />
              ) : (
                <Layout />
              )}
            </ErrorBoundary>
          </Interceptor>
        </Router>
      </AuthProvider>
    </MuiThemeProvider>
  </EnvProvider>
)

export default App
